export default "__VITE_ASSET__CDcjSbga__"